import { z } from "zod";
export const RichTextHtmlSchema = z.object({
    type: z.literal("html"),
    body: z.string().optional(),
});
export const RichTextPortableTextSchema = z.object({
    type: z.literal("portableText"),
    body: z.array(z.custom()).optional(),
});
export const RichTextSchema = z.union([RichTextHtmlSchema, RichTextPortableTextSchema]);
//# sourceMappingURL=index.js.map